// Hash routes: #/, #/result, #/profiles, #/profiles/<id>, #/profiles/<id>/rules/<n|new>, #/profiles/<id>/code
export function parseRoute(hash) {
  const path = (hash || "").replace(/^#/, "");
  if (path !== "" && !path.startsWith("/")) return { name: "convert" };
  let parts;
  try {
    parts = path.split("/").filter(Boolean).map(decodeURIComponent);
  } catch {
    return { name: "convert" };
  }
  if (parts.length === 0) return { name: "convert" };
  if (parts[0] === "result" && parts.length === 1) return { name: "result" };
  if (parts[0] === "demo" && parts.length === 1) return { name: "demo" };
  if (parts[0] === "profiles") {
    if (parts.length === 1) return { name: "profiles" };
    const id = parts[1];
    if (parts.length === 2) return { name: "profile", id };
    if (parts.length === 3 && parts[2] === "code") return { name: "code", id };
    if (parts.length === 4 && parts[2] === "rules") {
      if (parts[3] === "new") return { name: "rule", id, index: "new" };
      if (/^\d+$/.test(parts[3])) return { name: "rule", id, index: Number(parts[3]) };
    }
  }
  return { name: "convert" };
}

export function routeHash(route) {
  const id = route.id !== undefined ? encodeURIComponent(route.id) : "";
  switch (route.name) {
    case "result": return "#/result";
    case "demo": return "#/demo";
    case "profiles": return "#/profiles";
    case "profile": return `#/profiles/${id}`;
    case "rule": return `#/profiles/${id}/rules/${route.index}`;
    case "code": return `#/profiles/${id}/code`;
    default: return "#/";
  }
}
